import React from 'react';
import PropTypes from 'prop-types';
import ChevronIcon from '../../../../../icons/icon-chevron.svg';
import LocationIcon from '../../../../../icons/icon-location.svg';


export default function TriggerLink({ location, action, content }) {
  const locationName = location ? location.region : '';
  const { triggerCTA } = content;

  return (
    <div
      id="opco_navigator_modal_link"
      role="button"
      tabIndex="0"
      className="opco-navigator__modal-link"
      onClick={action}
      onKeyPress={action}
      aria-describedby="opco_navigator_modal_link_description"
    >
      <div className="opco-navigator-link">
        <div className="opco-navigator-link__location-icon"><LocationIcon /></div>
        <div className="opco-navigator-link__location-container">
          <div className="opco-navigator-link__shopping">{triggerCTA}</div>
          <div className="opco-navigator-link__location">
            {locationName}
            &nbsp;
            <span className="opco-navigator-link__dropdown-icon">
              <ChevronIcon />
            </span>
          </div>
        </div>
      </div>
      <span
        id="opco_navigator_modal_link_description"
        className="opco-navigator__modal-link-description"
      >
        {`Now ${triggerCTA} ${locationName}, click to change your location.`}
      </span>
    </div>
  );
}

TriggerLink.propTypes = {
  location: PropTypes.shape({
    region: PropTypes.string,
  }).isRequired,
  action: PropTypes.func.isRequired,
  content: PropTypes.shape({
    triggerCTA: PropTypes.string,
  }).isRequired,
};
